import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { AbstractColumn } from '../AbstractColumn/AbstractColumn';
import { jsx as _jsx } from "react/jsx-runtime";
export const Column = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AbstractColumn, Object.assign({}, rest, {
    columnType: "content",
    children: children
  }));
};